import * as RadixToggleGroup from '@radix-ui/react-toggle-group';
import { capitalize } from 'lodash';
import { memo, useCallback } from 'react';

import {
  isUpgradePlanModalBillingCycle,
  SUPPORTED_BILLING_CYCLES,
  type UpgradePlanModalBillingCycle,
} from '~/components/Modals/PlansModal/utils/planInfo';

export type UpgradePlanModalBillingCycleToggleProps = {
  billingCycle: UpgradePlanModalBillingCycle;
  onBillingCycleChange: (billingCycle: UpgradePlanModalBillingCycle) => void;
};

export const UpgradePlanModalBillingCycleToggle = memo(
  ({ billingCycle, onBillingCycleChange }: UpgradePlanModalBillingCycleToggleProps) => {
    const handleValueChange = useCallback(
      (value: string) => {
        if (!isUpgradePlanModalBillingCycle(value)) {
          return;
        }

        onBillingCycleChange(value);
      },
      [onBillingCycleChange],
    );

    return (
      <div className="flex w-full flex-1 justify-center">
        <RadixToggleGroup.Root
          className="flex h-8 w-max items-center gap-1 rounded-8 ads:bg-ads-gray-4 bg-gray-4 px-1"
          onValueChange={handleValueChange}
          orientation="horizontal"
          type="single"
          value={billingCycle}
        >
          {SUPPORTED_BILLING_CYCLES.map((value) => (
            <RadixToggleGroup.Item
              className="flex h-6 items-center justify-center rounded-6 px-1.5 font-medium ads:text-metadata text-14 text-gray-10 outline-none transition-colors ads:hover:bg-hover-subtle hover:bg-gray-6 ads:hover:text-primary hover:text-gray-12 ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 ads:data-[state=on]:bg-base data-[state=on]:bg-gray-1 ads:data-[state=on]:text-primary data-[state=on]:text-gray-12 ads:data-[state=on]:hover:bg-raised data-[state=on]:hover:bg-gray-2 ads:data-[state=on]:hover:text-secondary data-[state=on]:hover:text-gray-11"
              key={value}
              value={value}
            >
              {capitalize(value)}
            </RadixToggleGroup.Item>
          ))}
        </RadixToggleGroup.Root>
      </div>
    );
  },
);

UpgradePlanModalBillingCycleToggle.displayName = 'UpgradePlanModalBillingCycleToggle';
